import React, { Component } from "react";
import ContainerDimensions from "react-container-dimensions";

import { connect } from "../../utils";

const bgPropertiesDefault = {
  size: "cover",
  position: "center center",
  repeat: "no-repeat",
  ratio: 1.8
};

class Row extends Component {
  renderWithBackgroundImage = (values, children, contentWidth) => {
    const bgProps = values.bgProps ? values.bgProps : bgPropertiesDefault;
    const srcMobile =
      values.backgroundImage.urlMobile || values.backgroundImage.url || "";
    const srcDesktop =
      values.backgroundImage.url || values.backgroundImage.urlMobile || "";
    let important = {
      backgroundImage: `url("${srcDesktop}")`,
      backgroundSize: bgProps.size,
      backgroundPosition: bgProps.position,
      backgroundRepeat: bgProps.repeat
    };
    return (
      <ContainerDimensions>
        {({ width, height }) => {
          const minHeight = width / bgProps.ratio;
          if (width < 768) {
            important.backgroundImage = `url("${srcMobile}")`;
          }
          return (
            <div
              style={{
                ...important,
                minHeight: minHeight,
                display: "flex",
                width: "inherit",
                maxWidth: contentWidth
              }}
            >
              <div
                style={{
                  width: "inherit",
                  display: "flex",
                  alignItems: "stretch",
                  flexWrap: "wrap"
                }}
              >
                {children}
              </div>
            </div>
          );
        }}
      </ContainerDimensions>
    );
  };

  renderWithBackgroundColor = (values, children, contentWidth) => {
    return (
      <ContainerDimensions>
        {({ width, height }) => {
          return (
            <div style={{ maxWidth: contentWidth, width: "inherit" }}>
              <div
                style={{
                  width: "inherit",
                  display: "flex",
                  alignItems: "stretch",
                  flexWrap: "wrap"
                }}
              >
                {children}
              </div>
            </div>
          );
        }}
      </ContainerDimensions>
    );
  };

  render() {
    const { id, layoutState, children } = this.props;
    const { values } = layoutState.getItemJS(id).props;
    const valuesBody = layoutState.getItemJS("root").props.values;
    const contentWidth = values.width.contentWidth + values.width.type;
    const isBackgroundImage = values.isBackgroundImage
      ? this.renderWithBackgroundImage(values, children, contentWidth)
      : this.renderWithBackgroundColor(values, children, contentWidth);
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flex: 1,
          backgroundColor: values.backgroundColor,
          justifyContent: "center"
        }}
      >
        <div
          style={{
            boxSizing: "border-box",
            position: "relative",
            backgroundColor: values.backgroundColor,
            height: "100%",
            padding: values.padding,
            minHeight: children.length > 1 ? null : 30,
            minWidth: children.length > 1 ? null : 30,
            display: "flex",
            flex: 1,
            maxWidth: valuesBody.contentWidth,
            width: "inherit",
            justifyContent: "center"
          }}
        >
          {isBackgroundImage}
        </div>
      </div>
    );
  }
}

export default connect("layoutState")(Row);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/Row.js